<template>
  <div class="text-center">
    <v-icon v-if="icon" class="state-icon" large>{{ icon }}</v-icon>
    <div v-else class="state-icon">
      <slot />
    </div>
    <h2 v-if="title" class="title my-4">{{ title }}</h2>
    <v-subheader v-if="message" class="justify-center message">
      {{ message }}
    </v-subheader>
    <v-col class="d-flex justify-center">
      <v-btn
        v-if="actionText"
        color="accent"
        class="mt-5"
        @click="didClickAction()"
      >
        {{ actionText }}
      </v-btn>
    </v-col>
    <v-col v-if="refreshAction" class="d-flex justify-center">
      <v-btn icon color="secondary" @click="refreshAction()">
        <v-icon>refresh</v-icon>
        <!-- {{ $vuetify.lang.t('$vuetify.emptyState.refresh') }} -->
      </v-btn>
    </v-col>
  </div>
</template>

<script>
export default {
  name: 'EmptyStateCard',
  props: {
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    actionText: {
      type: String,
      default: ''
    },
    refreshAction: {
      type: Function
    }
  },
  methods: {
    didClickAction() {
      /**
       * Triggered when Call to Action button gets clicked
       * @event on-cta-click
       */
      this.$emit('on-cta-click')
    }
  }
}
</script>

<style>
.message.theme--light.v-subheader {
  max-width: 315px;
  margin: 0 auto;
}
.state-icon {
  font-size: 106px !important;
  color: #7089f9 !important;
}
/* .empty-state {
  min-height: 294px;
} */
</style>
